import React, { useState, useEffect } from "react";
import { FiKey, FiLock, FiX } from "react-icons/fi";
import { TbScan } from "react-icons/tb";
import { MdOutlineVerifiedUser, MdVerified } from "react-icons/md";
import EmailVerification from "../verificators/EmailVerification";

function CustomerCodeVerification({ onClose, zIndex, onVerifyCode }) {
  const [verifyEmailModal, setVerifyEmailModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [compData, setCompData] = useState({
    email: "",
  });
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    const savedCode = localStorage.getItem("customerCode");
    if (savedCode) {
      setCompData({ email: savedCode });
      setIsVerified(true);
    }
  }, []);

  useEffect(() => {
    const savedCode = localStorage.getItem("customerCode");
    if (savedCode && compData.email === savedCode) {
      setIsVerified(true);
    } else {
      setIsVerified(false);
    }
  }, [compData.email]);

  const openEmail = () => {
    const generatedOtp = Math.floor(100000 + Math.random() * 900000);
    setOtp(generatedOtp);
    setVerifyEmailModal(true);
  };

  const handleSave = async () => {
    if (compData.email === "") {
      alert("Enter Customer Code");
      return;
    }
    
    const generatedOtp = Math.floor(100000 + Math.random() * 900000);
    if (onVerifyCode) {
      onVerifyCode(compData, generatedOtp, (verified) => {
        handleSaveCustomercode(verified);
      });
    } else {
      setOtp(generatedOtp);
      setVerifyEmailModal(true);
    }
  };

  const handleSaveCustomercode = async (verified) => {
    if (!verified) {
      return;
    } else {
      localStorage.setItem("customerCode", compData.email);
      setIsVerified(true);
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 transition-all duration-300"
      style={{ zIndex: zIndex || 1000 }}
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[440px] overflow-hidden transform scale-100 transition-transform relative border border-slate-100 flex flex-col font-inter">
        {/* Modal Header */}
        <div className="flex items-center justify-between px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center text-white">
              <MdOutlineVerifiedUser className="text-xl" />
            </div>
            <div className="flex flex-col">
              <span className="font-semibold text-base tracking-wide font-inter">
                Verify Customer Code
              </span>
              <span className="text-blue-100 text-xs font-inter mt-0.5">
                Enter the code to authenticate and proceed
              </span>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 active:bg-white/30 transition-colors border-none cursor-pointer text-white"
          >
            <FiX className="text-lg" />
          </button>
        </div> 

        {/* Modal Body */}
        <div className="p-5 flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-[11px] font-bold tracking-wider text-slate-500 font-inter uppercase">
              Customer Code
            </label>
            <div className="relative flex items-center">
              <div className="absolute left-2.5 w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center text-slate-500">
                <FiKey className="text-sm" />
              </div>
              <input
                type="text"
                value={compData.email}
                onChange={(e) =>
                  setCompData({ ...compData, email: e.target.value })
                }
                placeholder="e.g. CUST-00123"
                className="w-full pl-12 pr-10 py-2 bg-slate-50 border border-slate-200 rounded-xl text-slate-800 placeholder-slate-400 focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all font-inter text-sm font-medium"
              />
              <div className="absolute right-3 text-blue-500 hover:text-blue-600 cursor-pointer flex items-center justify-center">
                <TbScan className="text-lg" />
              </div>
            </div>
            <span className="text-[11px] text-slate-400 font-inter mt-0.5">
              Enter or scan the unique customer identifier
            </span>
          </div>

          {/* Status Indicator */}
          <div className="bg-slate-50 border border-slate-100 rounded-xl px-4 py-2 flex items-center gap-2.5">
            <div className={`w-2 h-2 rounded-full ${isVerified ? "bg-emerald-500" : "bg-amber-500 animate-pulse"}`} />
            <span className="text-xs text-slate-600 font-inter font-medium">
              {isVerified 
                ? "Customer code verified successfully" 
                : "Awaiting code entry — no customer verified yet"}
            </span>
          </div>

          {/* Action Footer */}
          <div className="flex items-center gap-3 pt-1">
            <button
              onClick={onClose}
              className="flex-1 py-2.5 text-sm font-semibold text-slate-600 hover:text-slate-800 bg-white hover:bg-slate-50 border border-slate-200 active:bg-slate-100 rounded-xl transition-all flex items-center justify-center gap-2 cursor-pointer font-inter"
            >
              <FiX className="text-sm" />
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="flex-1 py-2.5 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 rounded-xl shadow-sm hover:shadow-md transition-all flex items-center justify-center gap-2 border-none cursor-pointer font-inter"
            >
              <MdVerified className="text-sm" />
              Verify & Save
            </button>
          </div>
        </div>

        {/* Footer Info Row */}
        <div className="px-6 py-3 bg-slate-50 border-t border-slate-100 flex items-center justify-between text-[11px] text-slate-400 font-inter">
          <span>SherGold ERP · CDB Settings</span>
          <div className="flex items-center gap-1">
            <FiLock className="text-[10px]" />
            <span>Secure</span>
          </div>
        </div>

        {/* Fallback rendering of EmailVerification for backwards compatibility */}
        {verifyEmailModal && (
          <EmailVerification
            onClose={() => {
              setVerifyEmailModal(false);
            }}
            data={compData}
            generatedOtp={otp}
            onVerified={(e) => {
              handleSaveCustomercode(e);
            }}
          />
        )}
      </div>
    </div>
  );
}

export default CustomerCodeVerification;
